import type { FC } from 'react'

import BurgerIcon from '@/assets/icons/burger-icon.svg?react'
import CloseIcon from '@/assets/icons/close-icon.svg?react'
import { usePageTitle } from '@/hooks/usePageTitle'
import { useAppStore } from '@/store/app'

export const Header: FC = () => {
  const toggleMenu = useAppStore((state) => state.toggleMenu)
  const isMenuOpen = useAppStore((state) => state.isMenuOpen)
  const pageTitle = usePageTitle()

  return (
    <div className="sticky left-0 top-0 z-20 flex h-[75px] items-center border-b border-[#0003] bg-white px-4 lg:hidden">
      <div className="my-auto flex">
        <button type="button" aria-label="Menu button" className="mr-4" onClick={() => toggleMenu()}>
          {isMenuOpen ? <CloseIcon width={32} /> : <BurgerIcon width={32} />}
        </button>
        <h1 className="text-xl font-medium">{pageTitle}</h1>
      </div>
    </div>
  )
}
